module.exports = __webpack_public_path__ + "img/op_img-header.cb24d66.png";